import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  NavLink,
  Link,
  useHistory,
} from "react-router-dom";
import { useEffect, useState } from "react";
import "../../schoolAdminPortal/schoolAdmin.css";
import schoolAdminLogo from "../../../assets/images/schoolAdminLogo.png";
import { render } from "react-dom";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import schooluser from "../../../assets/images/schooluser.png";
import wifi from "../../../assets/images/wifi.png";
import rending from "../../../assets/images/rending.png";
import featured from "../../../assets/images/featured.png";
// import groups from "../../assets/images/groups.png";
import vidoliabrary from "../../../assets/images/vidoliabrary.svg";
import schoolDashboard from "../../../assets/images/schoolDashboard.png";
// import highlightIMG from "../../assets/images/highlightIMG.png";
// import setting from "../../assets/images/setting.png";
import setting from "../../../assets/images/setting.png";

import scoaches from "../../../assets/images/scoaches.png";
import Sathelete from "../../../assets/images/Sathelete.png";
import sGroup from "../../../assets/images/sGroup.png";
import teams from "../../../assets/images/teams.png";
import sevents from "../../../assets/images/sevents.png";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import userService from "../../../services/user.service";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import { CircularProgress } from "@material-ui/core";
// import Container from "@material-ui/core/Container";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import Form from "react-bootstrap/Form";
import setnewimg from "../../../assets/images/setnewimg.png";
import successimg from "../../../assets/images/successimg.png";
import crosstick from "../../../assets/images/crosstick.png";
import DialogActions from "@material-ui/core/DialogActions";
import { BsXLg } from "react-icons/bs";
import schoolIcon from "../../../assets/images/schoolIcon.png";
import storageIcon from "../../../assets/images/storageIcon.png";
import paymentIcon from "../../../assets/images/paymentIcon.png";
import websiteIcon from "../../../assets/images/websideIcon.png";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
// Assets
import dashboardIconnew from "../../../assets/images/dashboardIconnew.png";
import List from "@material-ui/core/List";
import { includes, map, get } from "lodash";

import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInToLocalStorage,
} from "../../../utils/webStorage";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import {
  FaAngleDown,
  FaAngleRight,
  FaUserCog,
  FaRegEdit,
  FaPowerOff,
  FaUser,
  FaSchool,
  FaTimes,
  FaKey,
  FaDatabase,
  FaRegEnvelope,
  FaLock,
} from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import { Divider } from "@mui/material";

const menuId = "primary-search-account-menu";

const textProfile = {
  color: "black",
  textAlign: "right",
};

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    color: "white",
    background: "#01173E",
  },
  drawerContainer: {
    overflow: "auto",
  },
  dropdownbutton: {
    margin: theme.spacing(1),
    background: "#003594",
    color: "#FFFFFF",
    borderRadius: "22px",
    width: "80%",
    fontFamily: "Rajdhani-SemiBold",
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },

  dropdown: {
    position: "absolute",
    right: 0,
    left: "8px",
    zIndex: 1,
    padding: theme.spacing(0, 1),
    backgroundColor: "#003594",
    width: "80%",
    top: "108px",
    color: "#FFFFFF",
    borderRadius: "22px",
    textAlign: "center",
    fontFamily: "Rajdhani-SemiBold",
  },
  innerdropdown: {
    color: "#FFFFFF",
    fontFamily: "Rajdhani-SemiBold",
  },
  grow: {
    flexGrow: 1,
    textAlign: "right",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },

  inputRoot: {
    color: "inherit",
    background: "orange",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  tabs: {
    background: "#003594",
  },
}));
const MobileNavigation = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElog, setAnchorElog] = useState(null);
  const [UserName, setUserName] = useState(null);
  const [adminRole, setadminRole] = useState(null);
  const [schoolName, setschoolName] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [click, setClick] = React.useState(false);
  const [billingMsgFlag, showBillingMsgFlag] = useState(false);
  const [coachId, setCoachId] = useState(null);
  const [shortBilingMsg, setShortBilingMsg] = useState("");
  const [showBillingMsg, setShowBillingMsg] = useState("");
  const [msgCount, setCountMsgShow] = useState(0);
  const [loginLogo, setLoginLogo] = useState("");
  const [schoolLogoShow, setschoolLogoShow] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [openReset, setOpenReset] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [errorPassword, setError] = useState("");
  const [errorPasswordLength, setErrorLength] = useState("");
  const [openSuccess, setOpenSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  //   ///
  const [openValidationPop, setOpenValidationPop] = useState(false);
  const [openChange, setOpenChange] = useState(false);
  const [open, setOpen] = useState(false);
  //change email pop up
  //sucess pop up
  const [newEmail, setNewEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [oldEmail, setOldEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const [openChangeSuccess, setOpenChangeSuccess] = useState(false);
  const [logImage, setLogImage] = useState("");
  const [disabled, setDisabled] = useState(false);

  const currentRoute = useHistory().location.pathname.toLowerCase();

  // const { history } = props;
  const history = useHistory();
  const submitResetPassword = () => {
    var testFlag = false;
    if (password == confirmPassword) {
      if (
        password.length > 7 &&
        password.length < 14 &&
        confirmPassword.length > 7 &&
        confirmPassword.length < 14
      ) {
        testFlag = true;
        userService
          .resetPasswordSuperAdmin(oldPassword, password, confirmPassword)
          .then((response) => {
            if (response.data.success == true) {
              setError("");
              setErrorLength("");
              handleClickSucess();
            } else {
              setError("Something went wrong try again later!");
            }
          });
      } else {
        setErrorLength(
          "New password and Confirm Password length should between 8 to 14 character!"
        );
        setError("");
      }
    } else {
      setError("New password and Confirm Password not matched!");
      setErrorLength("");
    }
    if (testFlag == true) {
      setError("Please Check Old Password");
    }
  };
  const handleClickChangeSucess = () => {
    setOpenChangeSuccess(true);
  };
  const classes = useStyles();

  const handleClickCheckFalse = () => {
    setOpenValidationPop(false);
  };
  const changeEmailCall = () => {
    var adminEmail = getFromLocalStorage("superAdminEmail");
    userService
      .updateSuperAdminEmail(newEmail, adminEmail)
      .then((response) => {
        handleClickChangeSucess();
      })
      .catch((error) => {});
  };

  const handleClickCheckOpen = () => {
    setDisabled(true);
    if (newEmail != "" && emailError == "") {
      setOpenValidationPop(true);
      setEmailValidation(false);
      setDisabled(false);
    }
    if (newEmail == "") {
      setEmailValidation(true);
      setEmailError("");
      setDisabled(false);
    }
  };

  function logout() {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    history.push("/login");
  }
  const handleClickCloseSucess = () => {
    setOpenSuccess(false);
  };
  //sucess pop ups
  const handleClickSucess = () => {
    setOpenSuccess(true);
    setOpenReset(false);
  };

  const handleToCloseChnage = () => {
    setOpenChange(false);
  };

  const handleToCloseReset = () => {
    setOpenReset(false);
  };

  const handleClickCloseChangeSucess = () => {
    setOpenChangeSuccess(false);
  };
  const setNewEmailCall = (email) => {
    setNewEmail(email);
    setEmailValidation(false);
    if (email.length > 8) {
      userService.checkEmailInUser(email).then((response) => {
        if (response.data.data === "true") {
          setEmailError("Email is already exist! Please try with another!");
        } else {
          setEmailError("");
        }
      });
    }
  };
  const isMenuOpen = Boolean(anchorEl);
  const signOutClick = () => {
    removeFromLocalStorage("user");
    window.localStorage.clear();
    handleClickCloseChangeSucess();
  };

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleClickToOpenReset = () => {
    setOpenReset(true);
  };
  //change email
  const handleClickToOpenChange = () => {
    setOpenChange(true);
  };

  useEffect(() => {
    var UserName = getFromLocalStorage("loginUser");
    var adminRole = getFromLocalStorage("loginRole");
    var loginUserProfile = getFromLocalStorage("loginUserProfile");
    setUserName(UserName);
    setadminRole(adminRole);
    setLogImage(loginUserProfile);
  }, []);

  const itemsList = [
    {
      text: "Dashboard",
      icon: <img src={dashboardIconnew} alt="dashboard"></img>,
      onClick: () => history.push("/dashboarddata"),
    },
    {
      text: "Schools",
      icon: <img src={schoolIcon} alt="school"></img>,
      onClick: () => history.push("/schools"),
    },
    {
      text: "Storage",
      icon: <img src={storageIcon} alt="storage"></img>,
      onClick: () => history.push("/storage"),
    },
    {
      text: "Payments",
      icon: <img src={paymentIcon} alt="payment"></img>,
      onClick: () => history.push("/payment"),
    },
    {
      text: "Website",
      icon: <img src={websiteIcon} alt="website"></img>,
      onClick: () => history.push("/website"),
    },
  ];

  const renderMenu = (
    <Menu
      className="mt30"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
      <MenuItem className="profile-menuu-barr" onClick={handleClickToOpenReset}>
        <div className="black profile-menu-barr">
          <FaLock className="profile-menu-iconss" />
          Change Password
        </div>
      </MenuItem>
      <MenuItem
        className="profile-menuu-barr"
        onClick={handleClickToOpenChange}
      >
        <div className="black profile-menu-barr">
          <FaRegEnvelope className="profile-menu-iconss" />
          Change Email ID
        </div>
      </MenuItem>
      <MenuItem className="profile-menuu-barr" onClick={logout}>
        <div className="black profile-menu-barr">
          <FaPowerOff className="profile-menu-iconss" />
          Logout
        </div>
      </MenuItem>
    </Menu>
  );
  return (
    <div id="mobileNavbar">
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          <NavLink exact to="/superadmindashboard" className="nav-logo">
            <img
              src={schoolAdminLogo}
              alt="Logo"
              className="cp"
              nowrap="true"
            />
          </NavLink>

          <ul
            className={click ? "super-nav-menu active" : "super-nav-menu"}
            style={{ backgroundColor: "#fafafa !important" }}
          >
            <li className="nav-item profile-section">
              <Link exact className="nav-links" onClick={handleProfileMenuOpen}>
                <IconButton
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                  className="profile-btn"
                >
                  <Avatar src={loginLogo} />
                  <ListItem style={textProfile}>
                    <ListItemText
                      id="textPro"
                      style={{ textTransform: "capitalize" }}
                    />
                    <span>{UserName}</span>
                    <br></br>
                    <p className="mb-0">({adminRole})</p>
                  </ListItem>
                </IconButton>
              </Link>
            </li>

            <div>{renderMenu}</div>

            <Dialog
              open={openReset}
              onClose={handleToCloseReset}
              id="ResetPass"
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-10 col-lg-10 col-md-10">
                    <img src={setnewimg} alt="img"></img>
                    <label className="fs-18 semibold pl-3">
                      Reset Password
                    </label>
                  </div>
                  <div className="col-1 text-right ml-auto">
                    <BsXLg
                      onClick={handleToCloseReset}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <hr className="mt-0 mb-0"></hr>
              <DialogContent>
                <DialogContentText>
                  <Form>
                    <Form.Group>
                      <Form.Label>Current Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="****************"
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="****************"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>Confirm New password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="****************"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </Form.Group>
                    <label className="errorShow">{errorPassword}</label>
                    <label className="errorShow">{errorPasswordLength}</label>
                  </Form>
                  <button
                    type="submit"
                    className="btn w-100 btn-blue fs-20 bold border-0 text-light cp"
                    onClick={() => submitResetPassword()}
                  >
                    Update Password
                  </button>

                  <div className="clear20"></div>
                </DialogContentText>
              </DialogContent>

              <div className="clear20"></div>
            </Dialog>

            {/* change emaill pop up */}
            <Dialog
              open={openChange}
              onClose={handleToCloseChnage}
              id="Change_Email"
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-11 col-lg-11 col-md-11">
                    <label className="fs-18 semibold mb-0">
                      Change Registered Email
                    </label>
                  </div>
                  <div className="col-1 text-right ml-auto">
                    <BsXLg
                      onClick={handleToCloseChnage}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <hr className="mt-0 mb-0"></hr>
              <DialogContent>
                <DialogContentText>
                  <Form>
                    <Form.Group>
                      <Form.Label className="changeEmailtxt">
                        Enter Email
                      </Form.Label>
                      <Form.Control
                        type="email"
                        className="txtboxChange"
                        placeholder="exisitngemail@sample.com"
                        onChange={(e) => setNewEmailCall(e.target.value)}
                      />
                    </Form.Group>
                    {emailValidation == true && (
                      <Form.Label className="changeEmailtxt1">
                        Email is required
                      </Form.Label>
                    )}
                    <Form.Label className="changeEmailtxt1">
                      {emailError}
                    </Form.Label>
                  </Form>
                </DialogContentText>
              </DialogContent>
              <DialogActions className="d-block p-0">
                <div className="row float-end">
                  <div className="col-lg-6 col-6 text-right">
                    <button
                      className="btn btn-cancel fs-16 mb-3"
                      onClick={handleToCloseChnage}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-lg-6 col-6 text-left ">
                    <button
                      type="submit"
                      className={disabled ? "btn-save-active" : "btn-save"}
                      onClick={handleClickCheckOpen}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </DialogActions>

              <div className="clear20"></div>
            </Dialog>

            {/* sucess pop up */}
            <Dialog
              id="ChnagePassSucess"
              className="dialog-style"
              open={openSuccess}
              onClose={handleClickCloseSucess}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto "></div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="row">
                  <div className="col-12 text-center">
                    <img
                      src={successimg}
                      alt="success"
                      className="successimg-new"
                    ></img>
                    <div className="clear20"></div>
                    <p className="fs-20 semi-bold text-center">
                      Password changed successfully.
                    </p>
                    <div className="clear30"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <Link className="">
                      <button type="button" class="donebtn" onClick={logout}>
                        DONE
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="clear10"></div>

                <div className="clear10"></div>
              </DialogContent>
            </Dialog>

            {/* school remove pop up */}
            <Dialog
              id="dialogBoxRemove"
              className="dialog-style"
              open={openValidationPop}
              onClose={handleClickCheckFalse}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto mr-4">
                    <BsXLg
                      onClick={handleClickCheckFalse}
                      className="crossview cp"
                    ></BsXLg>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="clear10"></div>
                <div className="row">
                  <div className="col-12 text-center">
                    <p className="fs-20 semi-bold text-center">
                      Are you sure you want to change the login email id?
                    </p>
                    <div className="clear20"></div>
                  </div>
                  <div className="col-5 col-md-3 col-lg-3 ml-auto text-center mr-3">
                    <button
                      type="button"
                      class="cancelbtn"
                      onClick={handleClickCheckFalse}
                    >
                      No
                    </button>
                  </div>
                  <div className="clear10"></div>
                  <div className="col-5 col-md-3 col-lg-3 mr-auto text-center mr-3">
                    {/* <Link className="" to="/schoolCoaches"> */}
                    <button
                      type="button"
                      class="yes-btn"
                      onClick={changeEmailCall}
                    >
                      Yes, Update
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
                <div className="clear10"></div>
                <div className="clear10"></div>
              </DialogContent>
            </Dialog>
            {/* end  */}

            {/* Change Sucess */}
            <Dialog
              id="ChnageEmailSucess"
              className="dialog-style"
              open={openChangeSuccess}
              onClose={handleClickCloseChangeSucess}
            >
              <DialogTitle>
                <div className="row">
                  <div className="col-1 text-right ml-auto "></div>
                </div>
              </DialogTitle>
              <DialogContent>
                <div className="row">
                  <div className="col-12 text-center">
                    <img
                      src={successimg}
                      alt="success"
                      className="successimg-new"
                    ></img>
                    <div className="clear20"></div>
                    <p className="fs-20 semi-bold text-center">
                      Email changed successfully. You will be logged out and
                      need to login again.
                    </p>
                    <div className="clear30"></div>
                  </div>
                  <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
                    <Link to="/login" className="">
                      <button
                        type="button"
                        class="donebtn"
                        onClick={signOutClick}
                      >
                        DONE
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="clear10"></div>

                <div className="clear10"></div>
              </DialogContent>
            </Dialog>

            <div className={classes.drawerContainer}>
              <List id="superadmin">
                {map(itemsList, (item, index) => {
                  // const [text, icon] = item;
                  return (
                    <div id="superadmin_spacing" key={index}>
                      <ListItem id={item.text} button onClick={item.onClick}>
                        {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}

                        <ListItemText primary={item.text} />
                      </ListItem>
                    </div>
                  );
                })}
              </List>
            </div>
          </ul>
          <div onClick={handleClick}>
            {!click ? (
              <MenuIcon
                style={{ color: "black", fontSize: "40px", cursor: "pointer" }}
              />
            ) : (
              <CloseIcon
                style={{ color: "black", fontSize: "40px", cursor: "pointer" }}
              />
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default MobileNavigation;
